<template>
  <div class="FeatherMask">
    <Miniload v-if="!loaded" />
  </div>
</template>
<script>
import GLTFLoader from 'three-gltf-loader'
import Miniload from '@/components/miniload/Miniload'

export default {
  name: 'FeatherMask',
  props: ['found'],
  components: { Miniload },
  beforeDestroy() {
    this.$container.remove(this.$mask)
  },
  data: () => ({
    loaded: false
  }),
  watch: {
    found() {
      this.$container.visible = this.found
      this.$parent.$brfv4.t3d.render()
    }
  },
  activated() {
    if(this.$mask)
      this.$container.add(this.$mask)

    this.$parent.$brfv4.t3d.renderer.gammaFactor = 4
    this.$parent.$brfv4.t3d.renderer.gammaOutput = true

    this.$parent.$brfv4.t3d.face.visible = false
  },
  deactivated() {
    this.$container.remove(this.$mask)
    this.$parent.$brfv4.t3d.face.visible = true
  },
  created() {
    const loader = new GLTFLoader()
    this.$container = this.$parent.$brfv4.t3d.containers.eyebrow_middle

    loader.load(
      require('./mask.glb'),
      gltf => {
        this.$mask = gltf.scene
        this.$container.add(this.$mask)

        this.loaded = true

        this.$mask.traverse(child => {
          if(child.material) {
            const mat = child.material
            mat.map.encoding = THREE.GammaEncoding
            mat.flatShading = true
            mat.transparent = true
            // mat.metalness = 2
            mat.roughness = .7

            mat.needsUpdate = true
          }
        })


        TweenMax.set(this.$mask, { three: { rotationX: 180, rotationZ: 180, scale: .15, y: -.03, z: 0, x: -.05 } })
      }
    )
  }
}
</script>
